<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            opacity=".01"
            stroke="#979797"
            d="M.5.5h23v23H.5z"></path>
        <path
            class="gst-svg-icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.628 3h9.744c.349 0 .65.302.627.65v15.753c0 .348-.278.65-.65.65h-9.744a.649.649 0 0 1-.65-.65v-6.867h3.921v1.16c0 .394.44.603.766.371l2.854-2.158a.479.479 0 0 0 0-.765l-2.854-2.158a.468.468 0 0 0-.766.371v1.16h-3.898V3.65c0-.348.279-.65.65-.65ZM7.805 5.166a1.74 1.74 0 1 0-3.46-.376 1.74 1.74 0 0 0 3.46.376Zm1.62 4.68.79.533c.371.232.464.72.301 1.09a.79.79 0 0 1-1.09.233l-.789-.534a5.878 5.878 0 0 1-1.485-1.346l-.626 2.97 1.206 1.183c.487.488.835 1.09.998 1.764l.696 2.9a.939.939 0 0 1-.928 1.16c-.418 0-.789-.302-.905-.72l-.696-2.9a1.771 1.771 0 0 0-.487-.858s-2.274-2.204-2.46-2.39c-.443-.423-.379-.898-.293-1.532.012-.096.026-.196.038-.3l.056-.49a95.8 95.8 0 0 1 .13-1.111 4.503 4.503 0 0 0-1.021 1.276l-.371.696a.766.766 0 0 1-.696.417.735.735 0 0 1-.372-.093.781.781 0 0 1-.324-1.067l.37-.696A6.343 6.343 0 0 1 4.044 7.48c.603-.325.882-.44 1.16-.418l1.276.093c.395.023.673.186 1.787 1.624.325.418.72.766 1.16 1.068Zm-6.078 3.642.023.024c.086.063.623.58 1.16 1.095l.14.134c.04.04.076.08.112.118.07.075.136.146.212.207-.07.394-.185.742-.348 1.09l-1.461 3.11a.981.981 0 0 1-.859.533.82.82 0 0 1-.394-.093.96.96 0 0 1-.441-1.253l1.462-3.085a3.24 3.24 0 0 0 .208-.673l.186-1.207Z"
            fill="#184db4"></path>
    </svg>
</template>
<script>
export default {
    name: 'IconRunningMan',
};
</script>
